import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Icon, Modal, Segment, Tab } from "semantic-ui-react";

import { ROBSection, ROBSla } from "components/ROB/components";
import { useIsRobnetEnabled, useROB, useROBSLA } from "components/ROB/hooks";
import "components/ROB/ROB.scss";

import type { DealerLocationID } from "models";

type RobProps = {
  car_id: number;
  dealer_location_id?: DealerLocationID;
};

export const ROB = ({ car_id, dealer_location_id }: RobProps) => {
  const { t } = useTranslation();

  const isRobnetEnabled = useIsRobnetEnabled(dealer_location_id);
  const { data: contracts } = useROB(car_id, isRobnetEnabled);
  const { data: slas } = useROBSLA(car_id, isRobnetEnabled);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => setIsModalVisible(prev => !prev);

  if (!contracts) return null;

  const panes = [
    {
      menuItem: t("v8_contracts", "Contracts"),
      render: () => (
        <Tab.Pane>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <Segment>
                  <ROBSection title="lessor" data={contracts.lessor} />
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <ROBSection title="vehicle" data={contracts.vehicle} />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Segment>
                  <ROBSection title="leaseContract" data={contracts.leaseContract} />
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <ROBSection title="supplierContract" data={contracts.supplierContract} />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      )
    },
    ...(slas
      ? [
          {
            menuItem: "SLA",
            render: () => <Tab.Pane>{<ROBSla slas={slas} />}</Tab.Pane>
          }
        ]
      : [])
  ];

  return (
    <div className="ROB">
      <Button className="ROBButton -appointment-status" size="small" onClick={toggleModal}>
        ROB
      </Button>

      <Modal open={isModalVisible} className="ROBModal" size="fullscreen" dimmer="blurring">
        <Modal.Header className="title_header">
          <div>{t("v8_rob_info", "ROB Info")}</div>
          <Button basic onClick={toggleModal} className="close_button">
            <Icon className="xmark grey" size="big" />
          </Button>
        </Modal.Header>
        <Modal.Content scrolling>
          <Tab panes={panes} />
        </Modal.Content>
      </Modal>
    </div>
  );
};
